import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IBrandingService from "../contracts/IBrandingService";
import BrandingService from "../services/BrandingService";
import type { BrandingColors, TenantBranding } from "../models/Branding";

const service: IBrandingService = new BrandingService();

export function useBranding() {
  const { loading, error, execute } = useAsync();

  const get = useCallback(
    () => execute(() => service.get()) as Promise<TenantBranding | void>,
    [execute],
  );

  const updateAppearance = useCallback(
    (appName: string | null, colors: BrandingColors) =>
      execute(() => service.updateAppearance(appName, colors), {
        successMessage: "Apariencia actualizada",
      }) as Promise<TenantBranding | void>,
    [execute],
  );

  const uploadLogo = useCallback(
    (file: File) =>
      execute(() => service.uploadLogo(file), {
        successMessage: "Logo actualizado",
      }) as Promise<TenantBranding | void>,
    [execute],
  );

  const uploadFavicon = useCallback(
    (file: File) =>
      execute(() => service.uploadFavicon(file), {
        successMessage: "Favicon actualizado",
      }) as Promise<TenantBranding | void>,
    [execute],
  );

  const setDomain = useCallback(
    (domain: string) =>
      execute(() => service.setDomain(domain), {
        successMessage: "Dominio guardado. Crea el registro DNS y verifica.",
      }) as Promise<TenantBranding | void>,
    [execute],
  );

  const verifyDomain = useCallback(
    () =>
      execute(() => service.verifyDomain()) as Promise<TenantBranding | void>,
    [execute],
  );

  return {
    loading,
    error,
    get,
    updateAppearance,
    uploadLogo,
    uploadFavicon,
    setDomain,
    verifyDomain,
  };
}
